import { WaterCircleIcon } from './WaterCircleIcon';

/**
 * author: Michael Irigoyen
 * id 1A50CD86-0127-4730-A090-ED5110A9825F
 * name water-circle
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-circle.svg
 * tags
 * - Home Automation 
 */
export const DropCircleIcon = WaterCircleIcon;
export default DropCircleIcon